import { ArticleParagraph2 } from '@cian/ui-kit';
import * as React from 'react';
import { Link } from '../../../common/Link';
import { PaymentStatusContainer } from '../PaymentStatus';
import { useBalance } from '../../hooks';

export const BalanceDesktop = () => {
  const { showBalance, withPay, balanceString, handleDepositLinkClick } = useBalance();

  return (
    <div>
      {showBalance && !!balanceString && (
        <ArticleParagraph2 as="div">
          <div data-name="balance_desktop">Баланс:&nbsp;{balanceString}</div>

          {withPay && <Link onClick={handleDepositLinkClick}>Пополнить</Link>}
        </ArticleParagraph2>
      )}

      {showBalance && !balanceString && <ArticleParagraph2>Баланс</ArticleParagraph2>}

      <PaymentStatusContainer />
    </div>
  );
};
